import { useState, useEffect } from 'react';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { formatAmount, formatDateStrToDate, getToken } from '../utils';

function WithdrawalHistory() {
  const [isLoading, setIsLoading] = useState(false);
  const [refererWithrawalHistory, setRefererWithrawalHistory] = useState([]);

  const { token: userToken } = getToken();

  useEffect(() => {
    const fecthWithdrawalhistory = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/referrals/history`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setRefererWithrawalHistory(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fecthWithdrawalhistory();
  }, [userToken]);

  return (
    <section className='w-full bg-p-wh py-8 shadow-lg'>
      <h3 className='font-semibold text-[18px] text-p-bk pb-3 px-6'>
        Withdralwal History
      </h3>
      <div className='max-h-80 overflow-y-scroll'>
        {isLoading ? (
          <div className='w-full h-full flex justify-center'>
            <ReactLoading type='cylon' color='#5AC8FA' height={44} width={44} />
          </div>
        ) : refererWithrawalHistory.length === 0 ? (
          <div className='w-full h-full flex px-6'>
            <p className='font-medium'>No withdrawal </p>
          </div>
        ) : (
          refererWithrawalHistory?.map((withdrawal) => {
            const statusId = withdrawal?.withdrawal_status?.id;
            return (
              <div
                className='flex flex-row gap-4 w-full px-6 py-3 border-t-hf'
                key={withdrawal.id}
              >
                <div
                  className={`px-4 items-center justify-center flex rounded text-p-wh ${
                    statusId === 2
                      ? 'bg-green-500 hover:bg-green-400 focus:bg-green-600'
                      : statusId === 1
                      ? 'bg-orange-500 hover:bg-orange-400 focus:bg-orange-600'
                      : statusId === 3
                      ? 'bg-red-500 hover:bg-red-400 focus:bg-red-600'
                      : null
                  }`}
                >
                  {statusId === 1
                    ? 'P'
                    : statusId === 2
                    ? 'C'
                    : statusId === 3
                    ? 'D'
                    : null}
                </div>
                <div className='flex flex-row justify-between items-center w-full'>
                  <div>
                    <p>{formatDateStrToDate(withdrawal?.created_at)}</p>
                    <p className='text-xs text-s-bk'>
                      Status:{' '}
                      <span
                        className={`capitalize ${
                          statusId === 2
                            ? 'text-green-500'
                            : statusId === 1
                            ? 'text-orange-500'
                            : statusId === 3
                            ? 'text-red-500'
                            : null
                        }`}
                      >
                        {withdrawal?.withdrawal_status?.name}
                      </span>
                    </p>
                  </div>
                  <p>{formatAmount(withdrawal?.amount)}</p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </section>
  );
}

export default WithdrawalHistory;
